import { useContext } from 'react';
import { ThemeContext } from '../contexts/themeContext';

/**
 * @typedef {Object} ThemeColors
 * @property {string} primary - Cor primária.
 * @property {string} background - Cor de fundo.
 * @property {string} backgroundSecondary - Segunda cor de fundo.
 * @property {string} text - Cor do texto.
 * @property {string} textSecondary - Cor do texto.
 * @property {string} warning - Cor de aviso.
 * @property {string} info - Cor de informação.
 * @property {string} brand - Cor da marca.
 * @property {string} danger - Cor de perigo.
 * @property {string} loading - Cor de carregamento.
 * @property {string} success - Cor de sucesso.
 * @property {string} lightGray - Cor cinza claro.
 * @property {string} extralightGray - Cor cinza extra claro.
 * @property {string} lightGrayOpacity - Cor cinza claro opacidade.
 * @property {string} white - Cor branca.
 * @property {string} black - Cor preta.
 */

/**
 * @typedef {Object} Theme
 * @property {ThemeColors} colors - Cores do tema.
 */

/**
 * @typedef {Object} UseCustomThemeReturnType
 * @property {Theme} theme - Objeto contendo as cores do tema.
 * @property {'dark' | 'light'} themeSchema - Texto contendo o esquema cores do tema.
 * @property {(schema: 'dark' | 'light') => void} handleTheme - Função para manipular o tema.
 * @property {(primaryColor: string) => void} handlePrimaryColor - Função para manipular o cor principal.
 */

/**
 * Hook personalizado para utilizar o tema personalizado.
 * @returns {UseCustomThemeReturnType} O retorno contendo a função para manipular o tema e o objeto com as cores do tema.
 */
export const useCustomTheme = () => {
  const { handleTheme, theme, handlePrimaryColor, themeSchema } =
    useContext(ThemeContext);

  return { handleTheme, theme, handlePrimaryColor, themeSchema };
};
